import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SendPaymentInstructionRoutingModule } from '@pg-app/client/send-payment-instruction/send-payment-instruction-routing.module';
import { SendPaymentInstructionComponent } from '@pg-app/client/send-payment-instruction/containers/send-payment/send-payment-instruction.component';
import { ManageRecipientModule } from '@pg-app/client/manage-recipient/manage-recipient.module';
import { SendPaymentModalModule } from '@pg-app/client/client-dashboard/components/send-payment-modal/send-payment-modal.module';
import { AddNewRecipientFromSendPaymentComponent } from './containers/add-new-recipient/add-new-recipient-from-payment.component';

@NgModule({
  imports: [
    CommonModule,
    SendPaymentInstructionRoutingModule,
    ManageRecipientModule,
    SendPaymentModalModule
  ],
  declarations: [
    SendPaymentInstructionComponent,
    AddNewRecipientFromSendPaymentComponent
  ],
  entryComponents: [SendPaymentInstructionComponent]
})
export class SendPaymentInstructionModule { }
